import React from "react";
import styled from "styled-components";
import { theme } from "services/shared/StyledComponents";
import Image from "next/image";

const Container = styled.div.attrs({ className: "flex flex-col justify-end" })`
  width: 100%;
  background-color: #f7e0a9;
  padding-top: 2rem;
`;

const ImageContainer = styled.div.attrs({
  className: "flex flex-row w-auto py-0 px-10 mb-2",
})`
  width: 90%;
  justify-content: center;
  margin: auto;
  margin-top: 3rem;
`;

const LogoImage = styled.div.attrs({
  className: "w-full",
})<any>`
  height: 100px;
  width: ${(props: any) => props.width}px;
  margin-right: ${(props: any) => props.marginRight}vw;
`;

const Text = styled.h2.attrs({ className: "w-4/5" })`
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  border-bottom: 5px solid ${theme.colors.orange};
  padding-bottom: 1rem;
  margin: auto;
`;

const DesktopAsSeenIn = () => (
  <Container>
    <Text>AS SEEN IN</Text>
    <ImageContainer>
      <a href="https://www.axios.com/the-juggernaut-investors-south-asian-media-b9d5959b-547b-4a21-9f6b-eb3a1b347eee.html">
        <LogoImage marginRight="8" width="100">
          <Image
            src="/static/Axios-Logo-black.png"
            alt="Axios"
            width={100}
            height={25}
          />
        </LogoImage>
      </a>
      <a href="https://www.forbes.com/profile/snigdha-sur/">
        <LogoImage marginRight="8" width="100">
          <Image
            src="/static/Forbes_logo_black.png"
            alt="Forbes"
            width={100}
            height={26}
          />
        </LogoImage>
      </a>
      <a href="https://techcrunch.com/2019/03/12/the-juggernaut/">
        {" "}
        <LogoImage marginRight="8" width="60">
          <Image
            src="/static/Techcrunch-Logo-Black.png"
            alt="TechCrunch"
            width={60}
            height={30}
          />
        </LogoImage>
      </a>
    </ImageContainer>
  </Container>
);

export default () => (
  <>
    <DesktopAsSeenIn />
  </>
);
